<template>
  <div>
    <table align="center" style="margin-top:5px;margin-bottom: 10px">
      <tr data-v-effb2dc0="" style="background-color: rgba(154, 156, 158, 0.43);">
        <td data-v-effb2dc0="" style="width: 15%;">产品线</td>
        <td data-v-effb2dc0="">姓名</td>
        <td data-v-effb2dc0="">邮箱</td>
        <td data-v-effb2dc0="">负责区域/部门/产品</td>
      </tr>
      <tr>
        <td rowspan="7"> 园区</td>
        <td> 陈新辉</td>
        <td> chenxinhui@ruijie.com.cn</td>
        <td> 江苏、浙江、宁波、温州、上海、苏州、无锡</td>
      </tr>
      <tr>
        <td> 高远</td>
        <td> y_gao@ruijie.com.cn</td>
        <td> 北京、辽宁、黑龙江、天津、吉林、大连</td>
      </tr>
      <tr>
        <td> 李璐瑶1</td>
        <td> li1@ruijie.com.cn</td>
        <td> 川藏、云南、陕西、青海、宁夏、河南</td>
      </tr>
      <tr>
        <td> 芦剑豪</td>
        <td> lujianhao@ruijie.com.cn</td>
        <td> 新疆、山西、内蒙、甘肃、河北</td>
      </tr>
      <tr>
        <td> 王勇1</td>
        <td> wyong@ruijie.com.cn</td>
        <td> 重庆、广西、贵州、广东、佛山、深圳、东莞、海南</td>
      </tr>
      <tr>
        <td> 吴森旺1</td>
        <td> wusenwang1@ruijie.com.cn</td>
        <td> 福建、厦门</td>
      </tr>
      <tr>
        <td> 赵会东</td>
        <td> zhaohuidong@ruijie.com.cn</td>
        <td> 山东、湖北、湖南、安徽、青岛、江西</td>
      </tr>
      <tr>
        <td rowspan="6"> 数据中心</td>
        <td> 刘曦</td>
        <td> liux@ruijie.com.cn</td>
        <td> 运营商</td>
      </tr>
      <tr>
        <td> 张湘锐</td>
        <td> zhangxiangrui@ruijie.com.cn</td>
        <td> 金融</td>
      </tr>
      <tr>
        <td> 柯佑忠</td>
        <td> keyouzhong@ruijie.com.cn</td>
        <td> 公共安全、战略合作</td>
      </tr>
      <tr>
        <td> 宋子航</td>
        <td> songzihang@ruijie.com.cn</td>
        <td> 企业网东三省，华北，部委</td>
      </tr>
      <tr>
        <td> 游少鸿</td>
        <td> youshaohong@ruijie.com.cn</td>
        <td> 企业网华南</td>
      </tr>
      <tr>
        <td> 郑寒曦</td>
        <td> zhenghanxi@ruijie.com.cn</td>
        <td>企业网其他省份</td>
      </tr>
      <tr>
        <td rowspan="6"> 无线</td>
        <td> 陈子龙</td>
        <td> chenzilong@ruijie.com.cn</td>
        <td>上海、浙江</td>
      </tr>
      <tr>
        <td> 梁栋昱</td>
        <td> liangdongyu@ruijie.com.cn</td>
        <td> 湖南、湖北、山东、临沂、青岛、河南、内蒙</td>
      </tr>
      <tr>
        <td> 宋东旭</td>
        <td> songdongxu@ruijie.com.cn</td>
        <td> 天津、河北、黑龙江、吉林、辽宁、大连、北京</td>
      </tr>
      <tr>
        <td> 程钰智</td>
        <td> chengyuzhi@ruijie.com.cn</td>
        <td> 川藏、重庆、云南、贵州、陕西、山西、甘青、宁夏、新疆</td>
      </tr>
      <tr>
        <td> 牛众</td>
        <td> chizhanggui@ruijie.com.cn</td>
        <td> 江苏、安徽、苏州、无锡、宁波、温州、江西</td>
      </tr>
      <tr>
        <td> 池长贵</td>
        <td> chizhanggui@ruijie.com.cn</td>
        <td> 福建、厦门、广东、东莞、佛山、深圳、海南、广西</td>
      </tr>
      <tr>
        <td rowspan="4"> 路由</td>
        <td> 高云鹏</td>
        <td> gaoyunpeng@ruijie.com.cn</td>
        <td> 北京、天津、黑龙江、吉林、辽宁、内蒙、河北、宁夏、甘肃、陕西</td>
      </tr>
      <tr>
        <td> 简银</td>
        <td> jianyin@ruijie.com.cn</td>
        <td> 河南、湖北、湖南、广东、福建</td>
      </tr>
      <tr>
        <td> 陈鹏</td>
        <td> chenp@ruijie.com.cn</td>
        <td> 山东、山西、江苏、上海、浙江、安徽、江西</td>
      </tr>
      <tr>
        <td> 刘鑫</td>
        <td> liuxin@ruijie.com.cn</td>
        <td> 四川、重庆、广西、贵州、云南、青海、西藏、海南、新疆</td>
      </tr>
      <tr>
        <td rowspan="8"> 智慧教室</td>
        <td> 肖奇达</td>
        <td> xiaoqida@ruijie.com.cn</td>
        <td> 辽宁、大连、吉林、黑龙江</td>
      </tr>
      <tr>
        <td> 路建雷</td>
        <td> lujianlei@ruijie.com.cn</td>
        <td> 天津、河北、内蒙</td>
      </tr>
      <tr>
        <td> 蓝善良</td>
        <td> lanshanliang@ruijie.com.cn</td>
        <td> 广东、东莞、佛山、深圳、海南、福建、厦门、江西</td>
      </tr>
      <tr>
        <td> 张玉云</td>
        <td> zhangyuyun@ruijie.com.cn</td>
        <td> 北京、青岛、山东、山西</td>
      </tr>
      <tr>
        <td> 李伟8</td>
        <td> liwei8@ruijie.com.cn</td>
        <td> 湖北、湖南、河南、安徽</td>
      </tr>
      <tr>
        <td> 李文泽</td>
        <td> liwenze@ruijie.com.cn</td>
        <td> 陕西、青海、甘肃、宁夏、新疆</td>
      </tr>
      <tr>
        <td> 雷恒</td>
        <td> leiheng@ruijie.com.cn</td>
        <td> 浙江、温州、宁波、江苏、苏州、无锡、上海</td>
      </tr>
      <tr>
        <td> 晏洪洋</td>
        <td> yanhongyang@ruijie.com.cn</td>
        <td> 川藏、重庆、广西、云南、贵州</td>
      </tr>
      <tr>
        <td rowspan="6"> 云桌面</td>
        <td> 黄文彪</td>
        <td> huangwenbiao@ruijie.com.cn</td>
        <td> 厦门、广东、东莞、佛山</td>
      </tr>
      <tr>
        <td> 刘雅丽</td>
        <td> lyl@ruijie.com.cn</td>
        <td> 山东、青岛、安徽</td>
      </tr>
      <tr>
        <td> 王振宇</td>
        <td> wangzhenyu@ruijie.com.cn</td>
        <td> 重庆、云南、四川、贵州、广西、深圳、江西</td>
      </tr>
      <tr>
        <td> 杨方</td>
        <td> yangfang@ruijie.com.cn</td>
        <td> 新疆、陕西、山西、青海、宁夏、内蒙、甘肃、河南、海南、福建</td>
      </tr>
      <tr>
        <td> 张洪明</td>
        <td> zhanghongming@ruijie.com.cn</td>
        <td> 天津、辽宁、吉林、河北、大连、北京、黑龙江</td>
      </tr>
      <tr>
        <td> 左鹏</td>
        <td> zuopeng@ruijie.com.cn</td>
        <td> 无锡、苏州、上海、江苏、温州、浙江、南通、无锡、湖南、湖北</td>
      </tr>
      <tr>
        <td rowspan="7"> 身份管理</td>
        <td> 关天</td>
        <td> guantian@ruijie.com.cn</td>
        <td> 北京</td>
      </tr>
      <tr>
        <td> 李娟</td>
        <td> lijuan@ruijie.com.cn</td>
        <td> 天津、河南</td>
      </tr>
      <tr>
        <td> 张思</td>
        <td> zhangsi@ruijie.com.cn</td>
        <td> 川藏、福建、厦门、河北、大连、辽宁、吉林、黑龙江</td>
      </tr>
      <tr>
        <td> 蒋大伟</td>
        <td> jiangdawei@ruijie.com.cn</td>
        <td> 浙江、宁波、温州、江苏、苏州、无锡、上海</td>
      </tr>
      <tr>
        <td> 路富豪</td>
        <td> lufuhao@ruijie.com.cn</td>
        <td> 山东、青岛、山西、陕西、安徽、江西、内蒙</td>
      </tr>
      <tr>
        <td> 沈佳涛</td>
        <td> shenjiatao@ruijie.com.cn</td>
        <td> 广东、深圳、东莞、广西、湖南、贵州</td>
      </tr>
      <tr>
        <td> 黄小军</td>
        <td> huangxiaojun@ruijie.com.cn</td>
        <td> 重庆、云南、甘肃、青海、宁夏、新疆</td>
      </tr>
      <tr>
        <td rowspan="5"> 安全</td>
        <td> 牛国华</td>
        <td> niuguohua@ruijie.com.cn</td>
        <td> APT、BDS</td>
      </tr>
      <tr>
        <td> 赵悦桥</td>
        <td> zhaoyueqiao@ruijie.com.cn</td>
        <td> DBS、OAS、ELOG、RCP</td>
      </tr>
      <tr>
        <td> 任春林</td>
        <td> renchunlin@ruijie.com.cn</td>
        <td> DDP</td>
      </tr>
      <tr>
        <td> 徐国军</td>
        <td> xuguojun@ruijie.com.cn</td>
        <td> IDP、ISG、Scan、UAC、WG、行业网关EG</td>
      </tr>
      <tr>
        <td> 谢丽芳、辛胜博</td>
        <td>
          "xielifang@ruijie.com.cn、
          xinshengbo@ruijie.com.cn
        </td>
        <td> NGFW</td>
      </tr>
      <tr>
        <td> 睿智</td>
        <td> 胡雨晴</td>
        <td> huyuqing@ruijie.com.cn</td>
        <td> 全产品线</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ChanPx'
};
</script>

<style scoped>
  table td { padding: 10px 30px;
    border-bottom: 1px solid #999;
    border-right: 1px solid #999; }
  table { border-top: 1px solid #999;
    border-left: 1px solid #999;
    border-spacing: 0;
    font-size: 1.2rem;
  }

</style>
